<template>
  <div class="header-wrapper">
    <div class="top">
      <div v-show="routeName === 'index' || routeName === 'search'" class="location">
        <img class="icon-dizhi" src="../../assets/img/icon/icon_dizhi.png" alt="位置">
        <span>{{ getAddress(address) }}</span>
        <span class="btn">[切换城市]</span>
        <el-cascader v-model="address" :options="cascaderOption.slice(0,cascaderOption.length - 1)" :props="cascaderProps" size="mini" @change="handleCascaderChange" style="opacity: 0; width: 70px"></el-cascader>
      </div>
      <!-- <div class="tel">
        <img class="icon-dianhua" src="../../assets/img/icon/icon_dianhua.png" alt="电话">
        <label class="phone">020-86388001 转8061/8600</label>
      </div> -->
    </div>
    <div class="bottom">
      <img class="logo" src="../../assets/img/pic/pic_logo_rencai1.png" alt="首页" @click="routerGo('index')">
      <ul class="menu">
        <li
            v-for="(item, index) in menuList"
            :key="index"
            :class="{ 'current': item.pathName === routeName }"
            style="position: relative;"
            @click="routerGo(item.pathName)"
            :id="item.pathName"
        >{{ item.title }}<img style="position: absolute; top: -12px; right: -20px;" :src="item.gif" /></li>
      </ul>
      <div v-if="user.phone || user.username" class="yes-login">
        <img class="pic-user" :src="ajaxUrl.readFile(userInfo.avatar)" alt="我">
        <label class="userName" @click="toAccount">账户中心</label>
        <el-divider direction="vertical"></el-divider>
        <span class="logout" @click="handleClick_logout">退出</span>
      </div>
      <div v-else class="no-login">
        <div class="login" @click="routerGo('login')">登录</div>
        <div class="register" @click="routerGo('register')">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as ajaxUrl from '../../ajax.config.js';
  import { mapState } from 'vuex';
  import CHINA_REGION_OBJ from '@/mixins/chinaRegion';
  import { CHINA_REGION } from '../../mixins/chinaRegionArray.js';
  import gif from '../../assets/img/pic/HOT.gif';

  export default {
    name: 'Header',
    data() {
      return {
        ajaxUrl: ajaxUrl,
        address: ['440000'],
        cascaderOption: CHINA_REGION,
        cascaderProps: {
          checkStrictly: true
        },
        gif,
        menuList: [
          { title: '首页', pathName: 'index' },
          { title: '机关事业单位招聘', pathName: 'examine' },
          { title: '“百万英才汇南粤”2025年N城联动招聘活动', pathName: 'Air', gif: gif },
          { title: '企业招聘', pathName: 'workList' },
          { title: '人力资源服务', pathName: 'dispatchList' },
          { title: '最新动态', pathName: 'news' },
          { title: '帮助中心', pathName: 'help' },
          { title: '关于我们', pathName: 'aboutUs' }
        ]
      };
    },
    props: {
      userInfo: {
        type: Object
      }
    },
    computed: {
      ...mapState({ user: (state) => state.user }),
      ...mapState({ city: (state) => state.city }),
      // 当前路由name
      routeName() {
        return this.$route.name;
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (!this.city.address) {
          this.$store.dispatch('setCity', { address: this.address.join(';') });
        } else {
          this.address = this.city.address.split(';');
        }
      });
    },
    methods: {
      getAddress(address) {
        if (address.length === 1) {
          return address ? `${CHINA_REGION_OBJ[address[0]][0]}` : '';
        } else if (address.length === 2) {
          return address ? `${CHINA_REGION_OBJ[address[0]][0]} ${CHINA_REGION_OBJ[address[1]][0]}` : '';
        } else if (address.length === 3) {
          return address ? `${CHINA_REGION_OBJ[address[0]][0]} ${CHINA_REGION_OBJ[address[1]][0]} ${CHINA_REGION_OBJ[address[2]][0]}` : '';
        }
      },
      // 路由跳转
      routerGo(pathName) {
        this.$router.push({ name: pathName });
      },
      // 跳转账户中心
      toAccount() {
        if (this.user.userType === 1) {
          this.routerGo('pUserCenter');
        } else if (this.user.userType === 2) {
          this.routerGo('cUserCenter');
        } else if (this.user.userType === 3) {
          this.routerGo('aUserCenter');
        }
      },
      // 退出
      handleClick_logout() {
        this.$postDelete(ajaxUrl.authLogout).then(res => {
          this.$message({
            message: '账号已退出',
            type: 'success'
          });
          this.$store.dispatch('logout');
          window.location.href = '';
        });
      },
      // 省市区选择
      handleCascaderChange() {
        this.$store.dispatch('setCity', { address: this.address.join(';') });
        this.$emit('cityChange');
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "Header.sass"
</style>
<style scoped>
#Air{
  width: 185px;
  line-height: 20px;
  text-align: center;
}
</style>
